export const errors = {
	invalid_credentials: "Please verify your address mail and your password",
	no_internet: "Please check your internet connection",
	merchant_disabled: "this merchant was disabled",
	merchant_pending: "this merchant is pending",
	table_disabled_removed:
		"Sorry, the activation code you have entered does not exist",
	global_disabled_removed:
		"Sorry, the activation code you have entered does not exist",
	table_or_global_not_found: "Table or global merchant not found",
	table_or_global_disabled_removed:
		"Table or global merchant disabled or removed",
	choose_kiosk_mode: "Please choose your kiosk mode",
	menu: {
		423: "Table or global merchant not found"
	},
	merchant_not_found: "We can't find a merchant with that e-mail address.",
	invalid_order: " You can't pass an order less than $1.00 ",
	unauthorized: " Expired Session",
	locked: "The merchant account is locked."
};